import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/404.svg'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "card flex justify-content-center flex-column card-container h-full" }
const _hoisted_3 = { class: "flex align-items-center justify-content-center p-1" }

import { VueCookieNext } from 'vue-cookie-next';
import { useRouting } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const $routing = useRouting();

const onBack = () => {
  const lastRoute = VueCookieNext.getCookie('last_route');

  if (lastRoute) {
    $routing.redirectTo(lastRoute);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex align-items-center justify-content-center px-6 lg:p-1\" data-v-56fe92f1><img alt=\"404 Page Not Found\" src=\"" + _imports_0 + "\" data-v-56fe92f1></div><div class=\"flex align-items-center justify-content-center p-1\" data-v-56fe92f1><div class=\"w-10 sm:w-8 md:w-6 lg:w-4 text-sm text-center\" data-v-56fe92f1><span class=\"font-semibold\" data-v-56fe92f1> Sorry, this page either doesn&#39;t exist or you don&#39;t have the required permissions to view this page. </span><span data-v-56fe92f1>If you believe this is a mistake, please contact support.</span></div></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppButton, {
          type: "secondary",
          text: "Back",
          "icon-left": "arrow_back",
          onClick: onBack
        })
      ])
    ])
  ]))
}
}

})